/* eslint-disable @next/next/no-img-element */
const ImpressionPixel = ({
  impressionUrl,
}: {
  impressionUrl?: string | null;
}) => {
  return (
    impressionUrl && (
      <div data-test-id='impression-image'>
        <img width={0} height={0} src={impressionUrl} alt='' />
      </div>
    )
  );
};

export default ImpressionPixel;
